import { createAction } from '@reduxjs/toolkit';

export const revertAllLeadData = createAction('REVERT_ALL_LEAD_DATA');
export const revertAllLeadReferralData = createAction('REVERT_ALL_LEAD_REFERRAL_DATA');